import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['chips']

  connect() {
    this.scrollActiveChipIntoView()
  }

  scrollActiveChipIntoView() {
    if (!window.matchMedia('(max-width: 639px)').matches) return
    if (!this.hasChipsTarget) return

    const activeChip = this.chipsTarget.querySelector('[aria-current="page"], [aria-pressed="true"]')
    if (!activeChip) return

    requestAnimationFrame(() => {
      activeChip.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
    })
  }
}
